import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  icon?: ReactNode;
  loading?: boolean;
  fullWidth?: boolean;
}

const variantClass: Record<ButtonVariant, string> = {
  primary:   'btn-primary',
  secondary: 'btn-secondary',
  ghost:     'btn-ghost',
  danger:    'btn-secondary',
};

const variantStyle: Partial<Record<ButtonVariant, React.CSSProperties>> = {
  danger: { color: 'var(--loss)', borderColor: 'var(--loss-soft)' },
};

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = 'primary', icon, loading, fullWidth, className = '', style, disabled, children, type, ...rest },
  ref,
) {
  const isDisabled = disabled || loading;
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      disabled={isDisabled}
      className={[
        variantClass[variant],
        fullWidth ? 'w-full justify-center' : '',
        isDisabled ? 'opacity-50 cursor-not-allowed' : '',
        className,
      ].filter(Boolean).join(' ')}
      style={{ ...variantStyle[variant], ...style }}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
});
